import React from "react";
import EOpticAndCameraFeature from "../../../Model/EOpticAndCameraFeature";
import {
  UltravioletCaptureProperty,
  UltravioletFluorescenceCaptureProperty,
  VisibleCaptureProperty,
  VisibleFluorescenceCaptureProperty,
} from "../../../Model/CaptureProfile";
import { Gain } from "../../../Model/ImagerCapabilities";
import { BasicControl } from "../ImagerFeatureControls";

type GainControlProps = {
  disabled: boolean;
  gain: Gain;
  captureProperty:
    | VisibleCaptureProperty
    | VisibleFluorescenceCaptureProperty
    | UltravioletCaptureProperty
    | UltravioletFluorescenceCaptureProperty;
  onChange: (value: { gain: number }) => void;
};

export function GainControl({ gain, captureProperty, disabled, onChange }: GainControlProps) {
  if (captureProperty.gain == null) {
    throw new Error("Capture profile gain is null");
  }
  return (
    <BasicControl
      disabled={disabled}
      feature="Gain"
      id={EOpticAndCameraFeature.Gain}
      min={gain.minGain}
      max={gain.maxGain}
      value={captureProperty.gain}
      onValueChanged={(id, value) => {
        onChange({
          gain: value,
        });
      }}
      unit="dB"
      step={0.1}
    />
  );
}
